import { useCurrentSite } from '@hotjar/site';
import { useTranslation } from '@hotjar/translations';
import { SURVEYS } from '@hotjar/webapp/constants/routes';
import type { SurveyData } from '@hotjar/webapp/domains/activation/featured-insights/types';
import { epochDate } from '@hotjar/webapp/lib/time';
import { getRoute } from '@hotjar/webapp/utils/routing';
import { DetailsDefinition, DetailsLine, DetailsTitle, PageLinkLine } from '../../shared/styles';
import { PageLink } from './FeedbackSidebar';

export const SurveySidebar = ({ data }: { data: SurveyData }): JSX.Element => {
  const { t } = useTranslation();
  const { data: site } = useCurrentSite();
  const surveyLink = getRoute(SURVEYS.RESPONSES.path, {
    siteId: site?.id || '',
    surveyId: data?.surveyId || '',
  });

  return (
    <>
      <DetailsLine>
        <DetailsTitle>
          {t('activation:space-overview.for-you.featured-insights.slider.slide.survey.response')}:
        </DetailsTitle>
        <DetailsDefinition>{`#${data.surveyId}`}</DetailsDefinition>
      </DetailsLine>
      <DetailsLine>
        <DetailsTitle>
          {t('activation:space-overview.for-you.featured-insights.slider.slide.survey.date')}:
        </DetailsTitle>
        <DetailsDefinition>{epochDate(data.created, 'DD MMM YYYY')}</DetailsDefinition>
      </DetailsLine>
      <DetailsLine>
        <DetailsTitle>
          {t('activation:space-overview.for-you.featured-insights.slider.slide.survey.country')}:
        </DetailsTitle>
        <DetailsDefinition>{data.countryName}</DetailsDefinition>
      </DetailsLine>
      <DetailsLine>
        <DetailsTitle>
          {t('activation:space-overview.for-you.featured-insights.slider.slide.survey.user-id')}:
        </DetailsTitle>
        <DetailsDefinition>{data.shortVisitorUuid}</DetailsDefinition>
      </DetailsLine>
      <DetailsLine>
        <DetailsTitle>
          {t('activation:space-overview.for-you.featured-insights.slider.slide.survey.device')}:
        </DetailsTitle>
        <DetailsDefinition>{data.device}</DetailsDefinition>
      </DetailsLine>
      <PageLinkLine>
        {t('activation:space-overview.for-you.featured-insights.slider.slide.survey.page')}:
        <PageLink href={surveyLink} kind="standalone" isExternal>
          {surveyLink || ''}
        </PageLink>
      </PageLinkLine>
    </>
  );
};
